(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/communication-settings/communication-settings.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/communication-settings/communication-settings.js');

'use strict';

const {
  useState
} = React;
const {
  PersonalizationSettingsPanel
} = svs.myProfile.react.pages.communicationSettings.personalizationSettings;
const {
  CommunicationSettingsPanel
} = svs.myProfile.react.pages.communicationSettings.communicationSettings;
const CommunicationSettings = _ref => {
  let {
    isAdaptContent
  } = _ref;
  const [isPlayerLoggedIn] = useState(svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER));
  return React.createElement("div", {
    className: "margin-bottom-4"
  }, React.createElement(CommunicationSettingsPanel, null), isPlayerLoggedIn && React.createElement(PersonalizationSettingsPanel, {
    isAdaptContent: isAdaptContent
  }));
};
svs.myProfile.react.pages.communicationSettings.CommunicationSettings = CommunicationSettings;

 })(window);